import dayjs from "dayjs";
import { LiveInventoryTableFormat } from "../../types/equipment-inventory/liveInventory.type";

export const mockLiveInventory = {
  default: [
    {
      equipmentId: 1001,
      refNumber: "TRL-53-001",
      typeId: 2,
      typeName: "Trailer",
      lengthFt: 53,
      assignment: {
        name: "Route 101 - Downtown",
        id: "RT-101",
        type: "route",
      },
      door: 12,
      currentSealNumber: "SL-4567",
      lastUpdate: dayjs("2025-06-02T23:59:00"),
      daysAging: 2,
      ownership: {
        ownershipType: "C",
        ownershipScacCode: null,
      },
      status: {
        id: 1,
        name: "EMTY",
      },
    },
    {
      equipmentId: 1002,
      refNumber: "TRL-53-002",
      typeId: 1,
      typeName: "Tractor",
      lengthFt: 53,
      assignment: {
        name: "Trap 205 - North Yard",
        id: "TR-205",
        type: "trap",
      },
      door: 8,
      currentSealNumber: "SL-4568",
      lastUpdate: dayjs("2025-10-14T07:15:00"),
      daysAging: 1,
      ownership: {
        ownershipType: "V",
        ownershipScacCode: "CAEN",
      },
      status: {
        id: 2,
        name: "EMTY",
      },
    },
    {
      equipmentId: 1003,
      refNumber: "TRL-48-003",
      typeId: 2,
      typeName: "Trailer",
      lengthFt: 48,
      assignment: {
        name: "John Smith",
        id: "DR-001",
        type: "trip",
      },
      door: 15,
      currentSealNumber: null,
      lastUpdate: dayjs("2025-10-13T16:45:00"),
      daysAging: 5,
      ownership: {
        ownershipType: "V",
        ownershipScacCode: "XPS",
      },
      status: {
        id: 3,
        name: "CPLN",
      },
    },
    {
      equipmentId: 1004,
      refNumber: "TRL-48-006",
      typeId: 2,
      typeName: "Trailer",
      lengthFt: 48,
      assignment: {
        name: "Maria Garcia",
        id: "DR-002",
        type: "trip",
      },
      door: 3,
      currentSealNumber: null,
      lastUpdate: dayjs("2025-10-12T14:30:00"),
      daysAging: 8,
      ownership: {
        ownershipType: "V",
        ownershipScacCode: "XPS",
      },
      status: {
        id: 2,
        name: "EMTY",
      },
    },
  ],
} as const satisfies Record<string, LiveInventoryTableFormat[]>;
